import { ChangeEvent } from "../../events/ChangeEvent";
import { Checkbox } from "../checkbox/Checkbox";
import { CheckboxProps } from "../checkbox/CheckboxProps";
import { ComponentTypes } from "../../base/ComponentTypes";
import { PrintableEvent } from "../../events/PrintableEvent";
import { SelectCheckboxTableCellMixin } from "./SelectCheckboxTableCellMixin";
import { SelectionType } from "../../base/SelectionMode";
import { TableCell } from "./TableCell";
import { VerticalAlignment } from "@mcleod/core";
import { TableCellProps } from "./TableCellProps";
import { Table } from "./Table";

export class SelectCheckboxTableCell extends SelectCheckboxTableCellMixin(TableCell) {
    private providedVerticalAlign: VerticalAlignment;

    constructor(props?: Partial<TableCellProps>) {
        super(props);
        this.providedVerticalAlign = props?.verticalAlign;
    }

    override get table(): Table {
        return super.table;
    }

    override set table(value: Table) {
        super.table = value;

        // Set verticalAlign here so CENTER setting overrules automatic set of verticalAlign in Table._applyCellProps()
        if (this.providedVerticalAlign == null)
            this.verticalAlign = VerticalAlignment.CENTER;
    }

    protected override createCheckbox() {
        super.createCheckbox();
        this.checkbox.addChangeListener((event: ChangeEvent) => this.checkboxSelectedOnChange(event));
        this.checkbox.addPrintableListener((event: PrintableEvent) => this.checkboxSelectedOnPrintable(event));
    }

    protected override get addlCheckboxProps(): Partial<CheckboxProps> {
        return { id: "checkboxSelectRow" };
    }

    private checkboxSelectedOnChange(event: ChangeEvent) {
        if (this._designer != null)
            return;
        if (event.userInitiatedChange) {
            this.table.selectRow(this.row, SelectionType.DISTINCT, event.domEvent);
        } else {
            // If checkbox gets redisplayed from live update, resync it with the table's selected rows
            this.checkbox.checked = this.table.selectedRows.includes(this.row);
        }
    }

    private checkboxSelectedOnPrintable(event: PrintableEvent) {
        const checkbox = event.target as Checkbox;
        checkbox.printable = false;
    }
}
ComponentTypes.registerComponentType("selectcheckboxcell", {
    constructor: SelectCheckboxTableCell.prototype.constructor
});
